<template>
  <div class="not-found-page">
    <div class="not-found-content">
      <h1>404</h1>
      <p>抱歉，您访问的页面不存在</p>
      <router-link to="/" class="home-link">返回首页</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
/* 重置全局样式 */
body {
  margin: 0;
  padding: 0;
}

.not-found-page {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f9fa;
}

.not-found-content {
  text-align: center;
  padding: 50px 20px;
}

h1 {
  font-size: 120px;
  color: #2c3e50;
  margin: 0 0 20px;
  line-height: 1;
}

p {
  font-size: 24px;
  color: #666;
  margin-bottom: 30px;
}

.home-link {
  display: inline-block;
  padding: 12px 24px;
  background-color: #42b983;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  transition: background-color 0.3s;
  font-size: 18px;
}

.home-link:hover {
  background-color: #3aa876;
}
</style> 